<template>
  <router-link
    v-if="commercialPrint.actionsAvailable"
    :to="{ name: 'commercial-print-single', params: { id: commercialPrint.id } }"
  >
    <v-icon color="primary">
      mdi-bell-ring
    </v-icon>
  </router-link>
</template>

<script>
export default {
  props: {
    commercialPrint: {
      type: Object,
      required: true,
    },
  },
};
</script>
